import React, { useState } from "react";
import {
    Box,
    Container,
    Typography,
    TextField,
    Button,
    Card,
    CardContent,
    Stack,
    Avatar,
    Paper,
    Snackbar,
    Alert,
    useTheme,
    useMediaQuery,
} from "@mui/material";

import {
    EmailOutlined as EmailOutlinedIcon,
    PhoneOutlined as PhoneOutlinedIcon,
    LocationOnOutlined as LocationOnOutlinedIcon,
    AccessTimeOutlined as AccessTimeOutlinedIcon,
    Send as SendIcon
} from "@mui/icons-material";

import { ref, push, serverTimestamp } from "firebase/database";
import { rtdb } from "../services/firebase"; // ajuste se necessário


const textFieldSx = {
    "& .MuiInputLabel-root": { color: "rgba(0,0,0,0.55)" },
    "& .MuiInputLabel-root.Mui-focused": { color: "rgba(0,0,0,0.75)" },
    "& .MuiInputLabel-root.MuiInputLabel-shrink": { color: "rgba(0,0,0,0.55)" },
    "& .MuiFormHelperText-root": { color: "rgba(0,0,0,0.55)" },
}


export default function Contato() {
    const [form, setForm] = useState({
        nome: "",
        email: "",
        assunto: "",
        mensagem: "",
    });

    const [openSnack, setOpenSnack] = useState(false);
    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    function handleChange(e) {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);

        try {
            await push(ref(rtdb, "messages"), {
                ...form,
                createdAt: serverTimestamp(),
                createdAtFormatted: new Date().toLocaleString("pt-BR"),
            });

            setForm({ nome: "", email: "", assunto: "", mensagem: "" });
            setOpenSnack(true);
        } catch (err) {
            console.error("Erro ao enviar mensagem:", err);
        } finally {
            setLoading(false);
        }
    }

    const ContactItem = ({ icon, title, text, subtext }) => (
        <Stack direction="row" spacing={2} alignItems="flex-start">
            <Avatar sx={{ bgcolor: "primary.light", color: "primary.main", width: 48, height: 48 }}>
                {icon}
            </Avatar>
            <Box>
                <Typography fontWeight={700}>{title}</Typography>
                <Typography variant="body2">{text}</Typography>
                {subtext && <Typography variant="body2" opacity={0.7}>{subtext}</Typography>}
            </Box>
        </Stack>
    );

    return (
        <Box sx={{ bgcolor: "#F4F6F8", py: { xs: 6, md: 10 } }}>
            <Container maxWidth="lg">

                {/* HEADER */}
                <Box textAlign="center" mb={8}>
                    <Typography variant="overline" color="primary" fontWeight={700}>
                        FALE CONOSCO
                    </Typography>
                    <Typography variant="h3" fontWeight={800} mt={1}>
                        Estamos aqui para ajudar
                    </Typography>
                    <Typography maxWidth={600} mx="auto" mt={2}>
                        Tem alguma dúvida sobre nossos produtos ou seu pedido?
                        Preencha o formulário ou use um de nossos canais diretos.
                    </Typography>
                </Box>

                {/* CONTAINER PRINCIPAL */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        gap: 4,
                        alignItems: "stretch", // 🔥 chave para igualar alturas
                    }}
                >

                    {/* ESQUERDA */}
                    <Box sx={{ flex: 1, maxWidth: { md: 400 }, width: "100%" }}>
                        <Paper
                            sx={{
                                p: 4,
                                borderRadius: 4,
                                height: "100%", // 🔥 iguala altura
                                display: "flex",
                                alignItems: "center"
                            }}
                        >
                            <Stack spacing={4}>
                                <ContactItem icon={<EmailOutlinedIcon />} title="Email" text="emma.suporte@gmail.com " subtext="Respondemos em até 24h úteis" />
                                <ContactItem icon={<PhoneOutlinedIcon />} title="Telefone / WhatsApp" text="(31) 98102-0410" subtext="Seg a Sex, 9h às 18h" />
                                <ContactItem icon={<LocationOnOutlinedIcon />} title="Escritório" text="Av. Paulista, 1000" subtext="São Paulo - SP" />
                                <ContactItem icon={<AccessTimeOutlinedIcon />} title="Horário" text="Seg a Sex: 09h - 18h" subtext="Sáb: 09h - 13h" />
                            </Stack>
                        </Paper>
                    </Box>

                    {/* DIREITA */}
                    <Box sx={{ flex: 1 }}>
                        <Card sx={{ height: "100%", borderRadius: 4 }}>
                            <CardContent sx={{ height: "100%" }}>
                                <Typography variant="h5" fontWeight={700} mb={2}>
                                    Envie uma mensagem
                                </Typography>

                                <Box component="form" onSubmit={handleSubmit}>
                                    <Stack spacing={2}>
                                        <Box display="flex" gap={2} flexDirection={{ xs: "column", sm: "row" }}>
                                            <TextField fullWidth label="Seu Nome" name="nome" required value={form.nome} onChange={handleChange} sx={textFieldSx} />
                                            <TextField fullWidth label="Seu Email" name="email" required value={form.email} onChange={handleChange} sx={textFieldSx} />
                                        </Box>

                                        <TextField label="Assunto" name="assunto" fullWidth required value={form.assunto} onChange={handleChange} sx={textFieldSx} />
                                        <TextField label="Como podemos ajudar?" name="mensagem" fullWidth required multiline rows={5} value={form.mensagem} onChange={handleChange} sx={textFieldSx} />

                                        {/* BOTÃO CENTRAL */}
                                        <Box display="flex" justifyContent="center" mt={2}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                size="large"
                                                disabled={loading}
                                                endIcon={<SendIcon />}
                                                sx={{
                                                    width: "80%", // 🔥 80%
                                                    borderRadius: 3,
                                                    py: 1.5,
                                                    fontWeight: 700,
                                                    textTransform: "none",
                                                }}
                                            >
                                                {loading ? "Enviando..." : "Enviar Mensagem"}
                                            </Button>
                                        </Box>
                                    </Stack>
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>

                </Box>
            </Container>

            {/* FEEDBACK */}
            <Snackbar open={openSnack} autoHideDuration={4000} onClose={() => setOpenSnack(false)} anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
            }}>
                <Alert severity="success" variant="filled">
                    Mensagem enviada com sucesso!
                </Alert>
            </Snackbar>
        </Box>
    );
}